"use client";

import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
function ProductCategoriesConsumer() {
  const {
    terms,
    loading,
    error,
    refetch
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-96 rounded-2xl bg-muted/30 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return;
  }
  if (terms.length === 0) {
    return <p className="text-center text-muted-foreground py-12">
        No product categories available at this time.
      </p>;
  }
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      {terms.map((term, i) => <Link key={term.id} to={term.link || "#"} data-index={i} className="group block" style={{
      animationDelay: `${i * 100}ms`
    }}>
          <Card className="overflow-hidden border-0 shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
            <div className="relative aspect-[4/5] overflow-hidden rounded-2xl bg-muted">
              {term.image_url ? <img src={term.image_url} alt={term.name} className="h-full w-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-[1.02]" loading="lazy" style={{
            boxShadow: "inset 0 2px 8px rgba(0, 0, 0, 0.1)"
          }} /> : <div className="flex h-full w-full items-center justify-center bg-primary/20">
                  <span className="text-4xl text-muted-foreground opacity-40">
                    {term.name.charAt(0)}
                  </span>
                </div>}
            </div>
            <CardContent className="pt-4 px-0">
              <h3 className="text-lg font-display font-semibold text-foreground transition-colors duration-[var(--duration-fast)] group-hover:text-accent-dark">
                {term.name}
              </h3>
              {term.description && <p className="mt-2 text-sm text-muted-foreground line-clamp-2">
                  {term.description}
                </p>}
            </CardContent>
          </Card>
        </Link>)}
    </div>;
}
export default function ExploreOurProductCategories() {
  return;
}